let buyProduct = document.querySelector('.open-buy-now'),
    buyProductPopup = document.querySelector('.buy-product__full'),
    buySample = document.querySelector('.open-buy-sample'),
    buySamplePopup = document.querySelector('.buy-product__sample'),
    popupInner = document.querySelectorAll('.buy-product__inner'),
    body = document.querySelector('body'),
    closePopupButton = document.querySelectorAll('.js-buy-product-cart-close');

    if(buyProduct && buyProductPopup) {
      buyProduct.addEventListener('click', () => {
        body.classList.add('popup-active');
        buyProductPopup.classList.add('active');
      });

      buyProductPopup.addEventListener('click', () => {
        closePopup();
      });
    }

    if(buySample && buySamplePopup) {
      buySample.addEventListener('click', () => {
        body.classList.add('popup-active');
        buySamplePopup.classList.add('active');
      });

      buySamplePopup.addEventListener('click', () => {
        closePopup();
      });

    }

    closePopupButton.forEach((el) => {
      el.addEventListener('click', (e) => {
        closePopup();
      });
    })


    popupInner.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    })

    function closePopup() {
      body.classList.remove('popup-active');
      buyProductPopup.classList.remove('active');
      buySamplePopup.classList.remove('active');
    }


var variantSelectors = document.querySelectorAll('.buy-product__full .buy-product__variant'),  
    variantOptions = document.querySelectorAll('.buy-product__full .buy-product__variant-option');

    variantSelectors[0].classList.add('active');
    variantOptions[0].classList.add('active');


    for(var i = 0; i < variantSelectors.length; i++){
      variantSelectors[i].addEventListener('click', (e) => {
        variantSelectors.forEach(element => element.classList.remove('active'));
        e.target.classList.add('active');
        var dataNumber = e.target.dataset.number;

        variantOptions.forEach((item) => {
          item.classList.remove('active');

          if (item.dataset.number === dataNumber) {
            item.classList.add('active');
          }
        });
      });
    }


var selectedProduct = document.querySelectorAll('.buy-product__full .buy-product__option');

for(var i = 0; i < selectedProduct.length; i++){
  selectedProduct[i].addEventListener('click', function(e) {
    var price = document.querySelector('.buy-product__full .buy-product__total-cost');
    var amount = e.target.parentElement.dataset.value;
    document.querySelector('.buy-product__full .product-form__buy-button').disabled = false;

    if (e.target.classList.contains('quantity__button--plus')) {
      plus(e, price, amount);
    }
    if (e.target.classList.contains('quantity__button--minus') && amount > 0) {
      minus(e, price, amount);
    }
  });
}

var selectedSampleProduct = document.querySelectorAll('.buy-product__sample .buy-product__option');

for(var i = 0; i < selectedSampleProduct.length; i++){
  selectedSampleProduct[i].addEventListener('click', function(e) {
    var price = document.querySelector('.buy-product__sample .buy-product__total-cost');
    var amount = e.target.parentElement.dataset.value;
    document.querySelector('.buy-product__sample .product-form__buy-button').disabled = false;

    if (e.target.classList.contains('quantity__button--plus')) {
      plus(e, price, amount);
    }
    if (e.target.classList.contains('quantity__button--minus') && amount > 0) {
      minus(e, price, amount);
    }
  });
}


function plus(e, price, amount) {
  var oldAmount = parseInt(price.innerHTML.substring(1) * 100),
  addAmount = parseInt(e.target.parentElement.dataset.cost),
  newAmount = oldAmount + addAmount;
  amount++;
  e.target.parentElement.dataset.value = amount;
  price.innerHTML = Shopify.formatMoney(newAmount, window.moneyFormat.format);
  var minusIcon = e.target.parentElement.querySelector('.quantity__button--minus-icon'),
      deleteIcon = e.target.parentElement.querySelector('.quantity__button--delete-icon');
  if(amount == 1) {
    minusIcon.classList.remove('active');
    deleteIcon.classList.add('active');
  } else {
    minusIcon.classList.add('active');
    deleteIcon.classList.remove('active');
  }
}

function minus(e, price, amount) {
  var oldAmount = parseInt(price.innerHTML.substring(1) * 100);
  var addAmount = parseInt(e.target.parentElement.dataset.cost);
  var newAmount = oldAmount - addAmount;
  amount--;
  e.target.parentElement.dataset.value = amount;
  price.innerHTML =  Shopify.formatMoney(newAmount, window.moneyFormat.format);
  var minusIcon = e.target.parentElement.querySelector('.quantity__button--minus-icon'),
      deleteIcon = e.target.parentElement.querySelector('.quantity__button--delete-icon');
  if(amount == 1) {
    minusIcon.classList.remove('active');
    deleteIcon.classList.add('active');
  } else {
    minusIcon.classList.add('active');
    deleteIcon.classList.remove('active');
  }
}